<template>
    <div>
        <div v-if="fecha_actual!=0">
        <h1 id="TituloFecha">{{fecha_actual}}</h1>
        <hr id="Linea">
        </div>
        <div v-if="matriz_agenda_especialista.length!=0">
            <div id="InformaciónConsultaAsistida">
                <h1 id="TituloConsulta" @click="verPacientes()"> {{matriz_agenda_especialista.tipo_evento}} con neumólogo</h1>
                <button v-if="!bandera_ver_pacientes" id="BotonNumeroPacientes" @click="verPacientes()"> {{numero_pacientes_consulta}} pacientes </button>
                
                <div style="borderTop:1px solid #ccc; marginTop:3%" v-else-if ="bandera_ver_pacientes">
                    <div id="NombresPacientesConCita" v-for="(paciente,index) in matriz_nombres_pacientes_citas" :key="index">
                        <h2 id="NombresPacientesConCita" style="width:25%; fontWeight: bold;">{{paciente[1]}}</h2> 
                        <button id="NombresPacientesConCitaB" @click="informacionGeneralPaciente(paciente[2])" >{{paciente[0]}}</button> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { serverBus } from '../main'
import axios from '../apiService/config/axios.js'
import metodos_comunes from '../js/metodos_comunes'
// import variableEntorno from '../../static/config.json'

export default {
    data(){
        return{
            matriz_agenda_especialista:[],
            numero_pacientes_consulta: 0,
            matriz_nombres_pacientes_citas:[],
            fecha_actual:0,
            matriz_agenda:[],
            bandera_ver_pacientes:false,
            accion:'',
            cedula_paciente_consultado:'',
            endpointConsultarAgendas:''
        }
    },
    created(){
       
        this.endpointConsultarAgendas = "/controlador_datos/agendas/especialistas"
    
        
        // serverBus.$on('ConsultarAgenda', (agenda) =>{
        //     console.log("ConsultarAgendaRecibido", agenda )
        //     this.accion=agenda
        //     console.log("ConsultarAgendaRecibido", agenda )
        //     this.consultarAgendasEspecialistas()
            
        // })
        /**Recibe la variable que viene del bot que permite visualizar en la agenda la lista de pacientes de la consulta */
        // serverBus.$on('VerPacientesAgenda', (confirmacion) =>{
        //     console.log("VerPacientesAgenda", confirmacion )
        //     this.accion=''
        //     this.verPacientes2()
        //     this.bandera_ver_pacientes=true
            
        // })
        /**Recibe la variable que viene del bot que permite ocultar  la agenda la lista de pacientes  */
        //  serverBus.$on('NoVerPacientesAgenda', (confirmacion) =>{
        //     console.log("NoVerPacientesAgenda", confirmacion )
        //     this.fecha_actual=0
        //     this.matriz_agenda_especialista=[],
        //     this.bandera_ver_pacientes=false
        //     this.accion=''
        // })
        /**Recibe la variable presente en la respuesta del bot que permite resetear todas las variables y llevar el panel de agendas a los valores iniciales */
        // serverBus.$on("Reiniciar", (refresh_paciente) =>{
        //     this.resetear()
        // })
        
    },
    beforeDestroy(){
        serverBus.$off('consultarUsuarioDesdePanel')
        // serverBus.$off('ConsultarAgenda')
        // serverBus.$off('VerPacientesAgenda')
        // serverBus.$off('NoVerPacientesAgenda')
        // serverBus.$off('Reiniciar')
    },
    beforeUpdate() {
        console.log("accion", this.accion )
    },
    components:{
    },
    computed: {
        getReiniciar(){
            
            this.resetear()
            return this.$store.getters.getReiniciar
        },
        /**Recibe de la respuesta del bot la acción de consultar agendas*/
        getAccion(){
            this.consultarAgendasEspecialistas()
            return this.$store.getters.getAccion
        },
        getVerAgenda(){
            if(this.$store.getters.getVerAgenda!= null){
                console.log("VerPacientesAgenda", this.$store.getters.getVerAgenda )
                this.accion=''
                this.verPacientes2()
                this.bandera_ver_pacientes=true
            }
            return this.$store.getters.getVerAgenda
        },
        getSiguiente(){
            if(this.$store.getters.getSiguiente!= null){
                console.log("VerPacientesAgenda", this.$store.getters.getSiguiente )
                this.fecha_actual=0
                this.matriz_agenda_especialista=[],
                this.bandera_ver_pacientes=false
                this.accion=''
                
            }
            return this.$store.getters.getSiguiente
        },
        getLogHistoriaClinica(){
            if(this.$store.getters.getLogHistoriaClinica!= null){
                this.$store.dispatch('setVerAgenda', null)
            }
            return this.$store.getters.getLogHistoriaClinica
        }
    },
    watch: {
        getReiniciar(){},
        getAccion(){},
        getVerAgenda(){},
        getSiguiente(){},
        getLogHistoriaClinica(){}
        
    },
    methods:{
        informacionGeneralPacienteDesdePanel:function(){
            serverBus.$emit('consultarUsuarioDesdePanel', ["No",this.cedula_paciente_consultado])
            console.log('consultarInformacionGeneralPaciente',this.cedula_paciente_consultado )
        },

        /**Esta función permite reemplazar los caracteres previamente reemplazados para el almacenamiento 
         * de las variables. Es decir, devuelve la cadena de caracteres con la primera letra en mayuscula y
         * reemplaza el guión bajo por espacio.
         * @param {*} nombre Cualquier palabra en su forma original (sin simbolos especiales)
         */
        retomarCaracteresEspeciales(nombre) { //nombreFormulario
            nombre = nombre.toString().toLowerCase()
            nombre = nombre.charAt(0).toUpperCase() + nombre.slice(1)
            nombre = nombre.replace((/_/g), " ");
            return nombre
        },
        /**Consuta al endpoint de agendas la agenda del especialista 
         * @param {*} id_especialista nombre del especialista del que se va arealizar la consulta
         * @param {*} tipo_agenda el tipo de la egenda que e va a consultar
         * @param {*} fecha fecha en millis del dia que se quiere consultar
         */
        consultarAgendasEspecialistas:function(){
            let endpoint;
            let json = {};
            json["id_especialista"]='gabrieli@neumomed.com'
            json["tipo_agenda"]= 'consulta_asistida'
            json["fecha"]= 1548374400000
            console.log("consultarAgendasEspecialistas_json",json)
            endpoint= this.endpointConsultarAgendas
            axios.post(endpoint,json)
                .then(Response => {
                    this.matriz_agenda_especialista= Response.data.data
                    console.log("consultarAgendasEspecialistas_matrizAgendaR", Response.data.data)
                    this.matriz_agenda_especialista.tipo_evento = this.retomarCaracteresEspeciales( this.matriz_agenda_especialista.tipo_evento)
                    this.fecha_actual= this.convertirMilisegundosAFecha(this.matriz_agenda_especialista.eventos[0].data.fecha_cita)
                    this.numero_pacientes_consulta= this.matriz_agenda_especialista.eventos.length
                    console.log("consultarAgendasEspecialistas_matrizAgenda", this.matriz_agenda_especialista, this.matriz_agenda_especialista.length, this.matriz_agenda)
                    this.consultarCitaPacientes()
               })
                .catch(error => console.log("error",error)) 
        },
        /**Convierte en formato a.m p.m cualquier hora dada en millis
         * @param {*} hora hora en millis
         */
        convertirMilisegundosAHoraReloj(hora) { 
            let d = new Date(hora);
            let formato = 'a.m'
            let horas = d.getHours();
            let minutos = d.getMinutes();
            if(horas>=13){
                formato= 'p.m'
                horas= horas-12
            }
            if(minutos==0){
                minutos = '0'+'0' 
            }
            else if(minutos>=1 && minutos<=9 ){
                minutos = '0'+ minutos
            }
            hora  = horas + ":" + minutos + ' ' + formato
            return hora
        },
        /**Permite convertir de milisegundos a fecha con mes, dia, año y dia de la semana 
         * @param {*} fecha fecha en millis
        */
        convertirMilisegundosAFecha(fecha){
            let d = new Date(fecha);
            let semana = ["Domingo","Lunes", 'Martes', 'Miercoles', 'Jueves','Viernes', 'Sabado']
            let dia_semana= semana[d.getDay()]
            let dia= d.getDate()
            let mes = ['Enero', 'Febrero', 'Marzo','Abril','Mayo','Junio','Julio','Agosto', 'Septiembre','Octubre','Noviembre', 'Diciembre']
            let nombre_mes=mes[d.getMonth()]
            let year=d.getFullYear()
            fecha= dia_semana + ' ' + dia + ' ' + 'de' + ' ' + nombre_mes + ' ' + 'de' + ' '+ year
            return fecha

        },
        /**A partir de la respuesta de la consulta de la agenda del especialista se crea la matriz con el nombre del paciente y la hora de la cita
         * para ser visualizada 
         */
        consultarCitaPacientes:function(){  
            var i;
            let matriz=[]
            let fechaI;
            for (i = 0; i < this.numero_pacientes_consulta; i++) {
                console.log("nombre",this.matriz_agenda_especialista.eventos[i].data.variable)
                let variables= this.matriz_agenda_especialista.eventos[i].data.variable
                let vector=['','','']
                Object.keys(variables).forEach(function (key) {
                    let nombre_paciente;
                    console.log('key', key, variables[key])
                    console.log("nombreKey",variables[key] )
                    if (variables[key].nombre=="Nombre"){
                        nombre_paciente =  variables[key].valor
                        vector[0]=nombre_paciente
                        console.log('nombre_paciente', nombre_paciente)
                        console.log('nombre_paciente_vector[0]', vector[0])
                    }
                    if (variables[key].nombre=="Hora de la cita"){
                        let hora_de_la_cita=  variables[key].valor
                        vector[1]=hora_de_la_cita
                        console.log('hora_de_la_cita', hora_de_la_cita)
                        console.log('nombre_paciente_vector[1]', vector[1])
                    }
                    if (variables[key].nombre=="Identificación del paciente"){
                        let identificacion_paciente =  variables[key].valor
                        vector[2]=identificacion_paciente
                        console.log('identificacion_paciente', identificacion_paciente)
                        console.log('nombre_paciente_vector[2]', vector[2])
                    }
                    if(vector[0]!='' && vector[1]!=''&& vector[2]!=''){
                        matriz.push(vector)
                        vector=['','','']
                    }
                    if (variables[key].nombre=="Fecha de cita"){
                        let fecha_de_cita=  variables[key].valor
                        fechaI= fecha_de_cita
                        console.log('fecha_de_cita', fecha_de_cita)
                    }
                })
                this.matriz_nombres_pacientes_citas=matriz
                this.fecha_actual= this.convertirMilisegundosAFecha(fechaI)
                console.log('fecha_de_cita2', this.fecha_actual)
                console.log("matriz_nombres_pacientes_citas",this.matriz_nombres_pacientes_citas, matriz )
            }
            for (i = 0; i < this.numero_pacientes_consulta; i++) {
                let hora=matriz[i][1]
                this.matriz_nombres_pacientes_citas[i][1]=this.convertirMilisegundosAHoraReloj(hora)
            }
            console.log("matriz_nombres_pacientes_citas",this.matriz_nombres_pacientes_citas )
        },
        /** Este metodo permite ver los pacientes presentes en la agenda para cada tipo de consulta.
         * Se llama este metodo cuando desde el chat se da click en ver pacientes */
        verPacientes2:function(){
            this.bandera_ver_pacientes=!this.bandera_ver_pacientes  
        },
        /**Este metodo permite ver los pacientes presentes en la agenda para cada tipo de consulta. 
         * Envia un 'si' al chat al mostrar los pacientes para continuar el flujo de la conversacion */
        verPacientes:function(){
            this.bandera_ver_pacientes=!this.bandera_ver_pacientes
            if(this.getAccion=='agenda'){
                this.$store.dispatch('setMensajeChatBox', 'si')
                console.log('ok_prueba_agenda')
            }
        },
        informacionGeneralPaciente:function(cedula){
            this.cedula_paciente_consultado=cedula
            console.log('cedula_paciente_consultado', this.cedula_paciente_consultado)
            // serverBus.$emit('informacionGeneralPaciente',cedula);
            this.$store.dispatch("setCedulaPaciente", cedula)
            this.informacionGeneralPacienteDesdePanel()
        },
        /**Metodo que resetea todas las variables a su valor inicial */
        resetear:function(){
            console.log('resetear_agenda')
            this.matriz_agenda_especialista=[],
            this.numero_pacientes_consulta= 0,
            this.matriz_nombres_pacientes_citas=[],
            this.fecha_actual=0,
            this.matriz_agenda=[],
            this.bandera_ver_pacientes=false,
            this.accion=''
        }
    }
}
</script>
<style scoped>
#Linea{
    border: 0.7px solid #ccc;
    margin: 2px;
    width: 80%;
    margin: 1% auto 0px auto;
}
button:focus {outline:0;}
#InformaciónConsultaAsistida{
    width: 80%;
    border: 1.1px solid #999;
    border-radius: 10px;
    padding: 4%;
    margin: 5% 10% 5% 10%;
    box-shadow: -2px 3px 3px #ccc
}
#TituloConsulta{
    font-family: 'Nunito', sans-serif;
    font-size: 2.5vh;
    color: #999;
    font-weight: bold;
    margin: 0%;
}
#TituloFecha{
    font-family: 'Nunito', sans-serif;
    font-size: 2.7vh;
    color: #666;
    font-weight: bold;
    margin: 10% 10% 0px 10%;
    text-align: center;
}
#BotonNumeroPacientes{
    border: none;
    font-family: 'Nunito', sans-serif;
    font-size: 2vh;
    margin-top: 3%;
    color: #999;
    background: white;
    padding: 0%;
}
#NombresPacientesConCita{
    font-family: 'Nunito', sans-serif;
    font-size: 2vh;
    margin-top: 1%;
    color: #999;
    display: flex;
    justify-content: start;
}
#NombresPacientesConCitaB{
    border: 1px solid white;
    background-color:white;
    margin-left:2%; 
    border:none;
    border-radius: 15px;
    width: 75%;
    text-align: left;
}
#NombresPacientesConCitaB:hover {
    border: 1px solid whitesmoke;
    background-color: whitesmoke;
}

</style>



// WEBPACK FOOTER //
// src/components/Agenda.vue